import { useGalleryContext } from 'components/common/gallery';
import { useCounterScale } from 'components/location/pin/common';
import { IndexMarker } from 'components/progress/SimpleIndexMarker';
import {
  MouseEventHandler,
  ReactElement,
  useEffect,
  useState,
} from 'react';
import { Color } from 'shared/utils/colors';

export function IndexMarkerSvg({
  id,
  onClick,
  onMouseOver,
  onMouseLeave,
  color,
  drawLineFrom,
  width,
  left,
  top,
  zIndex,
  tooltip,
}: {
  id: string;
  onClick: MouseEventHandler;
  onMouseOver: MouseEventHandler;
  onMouseLeave: MouseEventHandler;
  color: Color;
  drawLineFrom: 'top' | 'bottom';
  width: number;
  left: string;
  top: string;
  zIndex: number | 'unset';
  tooltip: string;
}): ReactElement | null {
  const { rightPanelControls } = useGalleryContext();

  const initial = !rightPanelControls
    ? false
    : rightPanelControls?.getActivityStore().get() &&
      rightPanelControls?.getVisibleStore().get();
  const [showProgressMarkers, setShowProgressMarkers] = useState(initial);

  useEffect(() => {
    if (!rightPanelControls) {
      return;
    }
    const action = (): void => {
      const next =
        rightPanelControls?.getActivityStore().get() &&
        rightPanelControls?.getVisibleStore().get();

      setShowProgressMarkers(next);
    };

    action();
    const visibleUnsubscribe = rightPanelControls
      ?.getVisibleStore()
      .subscribe(action);
    const activeUnsubscribe = rightPanelControls
      ?.getActivityStore()
      .subscribe(action);

    return () => {
      visibleUnsubscribe();
      activeUnsubscribe();
    };
  }, [rightPanelControls]);

  const index = rightPanelControls?.getIndex(id);
  const counterScale = useCounterScale({ minScale: 0.6 });

  if (
    !rightPanelControls ||
    !showProgressMarkers ||
    rightPanelControls.getIndex(id) === -1
  ) {
    return null;
  }

  return (
    <svg
      viewBox={'0 0 20 14'}
      preserveAspectRatio={
        drawLineFrom === 'bottom' ? 'xMidYMin' : 'xMidYMax'
      }
      style={{
        width,
        height: width * 1.62,
        left,
        top,
        zIndex,
        position: 'absolute',
        transform:
          drawLineFrom === 'bottom'
            ? `translate(-50%, -2%) scale(${counterScale})`
            : `translate(-50%, -100%) scale(${counterScale})`,
        transformOrigin: drawLineFrom === 'bottom' ? '50% 0%' : '50% 100%',
      }}
    >
      <IndexMarker
        drawLineFrom={drawLineFrom}
        index={(index!) + 1}
        color={color}
        onMouseOver={onMouseOver}
        onMouseLeave={onMouseLeave}
        onClick={onClick}
        tooltip={tooltip}
      />
    </svg>
  );
}
